import { JobInput } from '@/types/job';
import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';

export default function job(axios: any) {
  async function getJobs(filter: any) {
    try {
      const response = await axios.get(`/api/boms?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/job] getJobs Error', e);
    }
    return null;
  }

  async function getJob(id: number) {
    const response = await axios.get(`/api/boms/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/job] getJob Error', e);
    }
    return null;
  }

  async function getLatestJob() {
    const response = await axios.get('/api/boms/latestBom');
    try {
      if (response.status === 200) {
        return response.data[0];
      }
    } catch (e) {
      console.error('[api/job] getLatestJob Error', e);
    }
    return null;
  }

  async function getJobStats() {
    const response = await axios.get('/api/boms/stats');
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/job] getStats Error', e);
    }
    return null;
  }

  async function createJob(payload: JobInput) {
    const response = await axios.post('/api/boms', camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/job] createJob Error', e);
    }
    return null;
  }

  async function updateJob(id: number | string, payload: JobInput) {
    const response = await axios.put(`/api/boms/${id}`, camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/job] updateJob Error', e);
    }
    return null;
  }

  async function deleteJob(id: number) {
    const response = await axios.delete(`/api/boms/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/job] deleteJob Error', e);
    }
    return null;
  }

  return {
    getJobs,
    getJob,
    getLatestJob,
    createJob,
    updateJob,
    deleteJob,
    getJobStats,
  };
}
